module.exports = __webpack_public_path__ + "img/img12.f406558d.png";